import "./Style/CustomSpinnerType1.Style.css"

export const CustomSpinnerType1=()=>{
 return <div id="CustomSpinnerType1Style"></div>   
}